import ApartmentStatistics from './ApartmentStatistics'

export default ApartmentStatistics
